import copyToClipboard from "copy-to-clipboard";

function copy(text: string): void {
    if (navigator.clipboard !== undefined) {
        try {
            void navigator.clipboard.writeText(text);
        } catch {
            // meh
        }
        return;
    }
    copyToClipboard(text);
}

export default copy;
